import { render, staticRenderFns } from "./StatWait.vue?vue&type=template&id=315fccf2&scoped=true&"
import script from "./StatWait.vue?vue&type=script&lang=js&"
export * from "./StatWait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315fccf2",
  null
  
)

export default component.exports